import { SlotGameType1_2 } from "../SlotGameType1_2";
import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import {  FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
import { SetStyles } from "../.././MyHelpers";

// export namespace SlotGames2
// {
	export class AmazingPanda2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory:ISlideFactoryGeneric= new FactoryDoubleSlide();

		
		protected override PaytableLoaded(resourceManager: IReadOnlyResourceManager): void 
		{
			super.PaytableLoaded(resourceManager);
			SetStyles(this.view.querySelectorAll(".paytable-symbol-container"),
			{
				//HIDE BACKGROUND
				//backgroundColor:"rgba(0, 0, 0, 0.6)",
			});
		}

		
		// protected PrepareFonts(resourceManager: ResourceManager): void 
		// {
	
		// 	resourceManager.Add(new FontResource(this.basepath + "go3v2.ttf", this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }

	
	}


// }
